import { Clock, FloppyDisk, ShieldCheck, Compass } from '@phosphor-icons/react';

const PROMISES = [
  {
    icon: Clock,
    title: 'About 20 minutes',
    body: 'You do not have to do it in one sitting.',
  },
  {
    icon: FloppyDisk,
    title: 'Saved as you go',
    body: 'Every answer is stored the moment you write it.',
  },
  {
    icon: Compass,
    title: 'Five directions',
    body: 'You will choose which ones appeal to you most.',
  },
  {
    icon: ShieldCheck,
    title: 'Yours to control',
    body: 'You decide what to share and what to leave out.',
  },
];

export default function WelcomeStep({ resuming, completion }) {
  return (
    <section className="ob-card">
      <span className="ob-eyebrow">Internship Programme</span>

      <h1 className="ob-h1">
        {resuming ? 'Welcome back' : 'Let’s build your Talent Profile'}
      </h1>

      <p className="ob-lede">
        {resuming
          ? `You are ${completion}% of the way there. Everything you wrote is still here — pick up wherever you left off.`
          : 'This is not an application form. It is a profile of who you are, what you can do and where you want to go — the same picture your mentors will work from on day one.'}
      </p>

      {!resuming && (
        <p className="ob-lede">
          There are no right answers. The more honest you are, the better we can
          place you somewhere you will actually enjoy.
        </p>
      )}

      <div className="ob-body">
        <div className="ob-choices" data-cols="2">
          {PROMISES.map(({ icon: Icon, title, body }) => (
            <div key={title} className="ob-choice" style={{ cursor: 'default' }}>
              <Icon size={20} weight="duotone" style={{ color: '#4f46e5', flexShrink: 0, marginTop: 1 }} />
              <span className="ob-choice-text">
                <span className="ob-choice-title">{title}</span>
                <span className="ob-choice-hint">{body}</span>
              </span>
            </div>
          ))}
        </div>
      </div>

      <p className="ob-encourage">
        <span>
          We will start with the basics, then move on to the more interesting
          parts — your skills, how you like to work, and the direction you want
          to head in.
        </span>
      </p>
    </section>
  );
}
